import {
    Button,
    Card,
    Col,
    Form,
    notification,
    Row,
    Skeleton,
    Typography,
    theme,
} from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { decrypt, formatDate, weekDays } from "../../services/util";
import CustomHeader from "../common/Header";
import { DashboardGrids } from "../Home/Home";
import "./HotelWidget.css";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { MyCustomUploadAdapterPlugin } from "./uploadAdapter";

const titleMapings = {
    name: "Name",
    email: "Email",
    phone: "Phone",
    street: "Street",
    city: "City",
    state: "State",
    zipcode: "ZipCode",
    country_code: "Country Code",
    tz_id: "Time Zone",
    vendor_name: "Vendor Name",
    person_name: "Person Name",
    person_email: "Email",
    phone_number: "Phone",
    notes: "Notes",
    property_name: "Property Name",
    live_date: "Live Date",
    property_address: "Property Adderess",
    property_city: "Property City",
    property_state: "Property State",
    property_zip_code: "Property Zipcode",
    brand: "Brand",
    ship_date: "Ship Date",
    lock_provider: "Lock Provider",
    property_key: "Property Key",
    property_key_software: "Property Key SoftWare",
    pbx: "PBX",
    pms: "PMS",
    gen_kiosk: "Kiosk Generation",
    number_of_kiosk: "No. of Kiosk",
    credit_terminal: "Credit Terminal",
    shifts: "Shifts",
    kiosk_serial: "Kiosk Serial",
    internet_service: "Internet Service",
    kiosk_id: "Kiosk Id",
    him_version: "HIM version",
    tti_version: "TTI version",
    desktop_name: "Desktop Name",
    anydesk: "Anydesk",
    ip_address: "IP Address",
    kiosk_version: "Kiosk Version",
    pbx_contact: "PBM contact",
    lock_contact: "Lock contact",
    pms_contact: "PMS contact",
    pms_url: "PMS Url",
    pms_user_id: "PMS User Id",
    lock_user_id: "Lock User Id",
    confluence_url: "Confluence Url",
    bill_acceptor_port_number: "Bill Acceptor Port Number",
    bill_dispenser_port_number: "Bill Dispenser Port Number",
    printer_port_number: "Printer Port Number",
    key_dispenser_port_number: "Key Dispenser Port Number",
    module_service_version_number: "Module Service Version",
    health_monitor_version_number: "Health Monitor Version",
    ftp_service_version_number: "FTP Service Version",
    support_user: "Support User",
    kiosk_number: "Kiosk Number",
    shift_type: "Shift Type",
    shift_timings: "Shift Timings",
    shift_settings: "Shift Settings",
    kiosk_property_notes: "Kiosk Property Notes",
    kiosk_frontdesk_agents: "Kiosk FrontDesk Agents",
};
function HotelDashboard() {
    const { token } = theme.useToken();
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [search] = useSearchParams();
    const hotel_id = decrypt(`${search.get("id").replace("plus", "+")}`);
    const { selectedDates } = useContext(SettingContext);
    const [start_date, end_date] = selectedDates;
    const [kioskStatistics, setKioskStatistics] = useState();
    const [hotelInfo, setHotelInfo] = useState({});
    const [vendorInfo, setVendorInfo] = useState([]);
    const [tickets, setTickets] = useState();
    const [kioskProperties, setKioskProperties] = useState({});
    const [editorText, setEditorText] = useState(null);
    const navigate = useNavigate();
    const editorRef = React.createRef();
    const [myEditor, setMyEditor] = useState(null);

    const [formData, setFormData] = useState({
        staff_id,
        hotel_id,
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
    });

    const {
        status: KioskStatisticsStatus,
        data: KioskStatisticsRes,
        refetch: getKioskStatistics,
    } = useQuery(
        ["hotel-dashboard-kiosk-staistics", hotel_id],
        async () =>
            await HTTP("/hotels/getSingleHotelDashboard", { ...formData }),
        {
            select: (data) => {
                const cardData = DashboardGrids.reduce((prev, cur) => {
                    if (data.data?.[cur.key] !== undefined) {
                        cur.value = data.data[cur.key] || 0;
                        prev.push(cur);
                    }
                    return prev;
                }, []);
                return {
                    hotel_name: data.data.hotel_name,
                    hotel_id: data.data.hotel_id,
                    cardData,
                };
            },
            enabled: false,
        },
    );
    const {
        status: notesStatus,
        data: notesRes,
        refetch: getNotes,
    } = useQuery(
        ["hotel-dashboard-notes", hotel_id],
        async () =>
            await HTTP("/hotels/getSingleHotelNotes", {
                staff_id,
                hotel_id,
            }),
        {
            enabled: false,
        },
    );

    const {
        status: infoStatus,
        data: infoRes,
        refetch: getInfo,
    } = useQuery(
        ["hotel-dashboard-info", hotel_id],
        async () =>
            await HTTP("/hotels/getSingleHotelDashboardInfo", {
                staff_id,
                hotel_id,
            }),
        {
            enabled: false,
        },
    );

    const {
        status: ticketStatus,
        data: ticketRes,
        refetch: getTicket,
    } = useQuery(
        ["hotel-dashboard-ticket", hotel_id],
        async () =>
            await HTTP("/hotels/getSingleHotelDashboardTickets", {
                ...formData,
            }),
        {
            enabled: false,
        },
    );

    const {
        status: kioskPropertiesStatus,
        data: kioskPropertiesRes,
        refetch: getKioskProperties,
    } = useQuery(
        ["hotel-dashboard-kiosk-properties", hotel_id],
        async () =>
            await HTTP("/hotels/getSingleHotelDashboardKioskProperty", {
                staff_id,
                hotel_id,
            }),
        {
            enabled: false,
        },
    );

    useEffect(() => {
        getKioskStatistics();
        getInfo();
        getTicket();
        getKioskProperties();
        getNotes();
    }, []);

    async function createEditor(editorData) {
        return new Promise((resolve, reject) => {
            const root = editorRef.current;

            if (!root) {
                return;
            }
            ClassicEditor.create(root, {
                extraPlugins: [MyCustomUploadAdapterPlugin],
            })
                .then((editor) => {
                    editor.data.set(editorData);
                    setMyEditor(editor);
                    resolve();
                })
                .catch((err) => reject("not abale to create editor"));
        });
    }

    useEffect(() => {
        getKioskStatistics();
        getInfo();
        getTicket();
        getKioskProperties();
        getNotes();
    }, [formData]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        if (KioskStatisticsStatus == "success")
            setKioskStatistics(KioskStatisticsRes);
    }, [KioskStatisticsStatus, KioskStatisticsRes]);

    useEffect(() => {
        if (infoStatus == "success") {
            setHotelInfo(infoRes.data);
            setVendorInfo(infoRes.data.vendor_info);
        }
    }, [infoStatus, infoRes]);

    useEffect(() => {
        if (ticketStatus == "success") setTickets(ticketRes.data);
    }, [ticketStatus, ticketRes]);

    useEffect(() => {
        if (kioskPropertiesStatus == "success")
            setKioskProperties(kioskPropertiesRes.data);
    }, [kioskPropertiesStatus, kioskPropertiesRes]);

    useEffect(() => {
        if (notesStatus == "success") {
            setEditorText(
                notesRes.data.length > 0 ? notesRes.data[0].notes : "",
            );
        }
    }, [notesStatus, notesRes]);

    useEffect(() => {
        if (myEditor == null) createEditor(editorText);
    }, [editorText]);

    async function saveHotelNotes() {
        const { success, message } = await HTTP(
            "/hotels/addEditSingleHotelNotes",
            {
                staff_id,
                hotel_id,
                notes: myEditor.data.get(),
            },
        );
        if (success) {
            notification["info"]({ message });
        } else {
            notification["error"]({ message });
        }
        getNotes();
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            <Card hoverable className="margin-10 box-shadow">
                <div
                    style={{ justifyContent: "space-between", display: "flex" }}
                >
                    <Typography.Text strong>
                        {kioskStatistics?.hotel_name}
                    </Typography.Text>
                    <div>
                        <Typography.Text strong className="margin-right-5">
                            Tickets:
                        </Typography.Text>
                        <>
                            <Button
                                className="margin-right-5"
                                onClick={() =>
                                    tickets?.open_tickets
                                        ? navigate(
                                              `/hotel-dashboard/tickets/1?id=${search.get(
                                                  "id",
                                              )}`,
                                          )
                                        : null
                                }
                            >{`Open: ${tickets?.open_tickets || 0}`}</Button>
                            <Button
                                onClick={() =>
                                    tickets?.close_tickets
                                        ? navigate(
                                              `/hotel-dashboard/tickets/2?id=${search.get(
                                                  "id",
                                              )}`,
                                          )
                                        : null
                                }
                            >{`Closed: ${tickets?.close_tickets || 0}`}</Button>
                        </>
                    </div>
                </div>
            </Card>
            <Row>
                <Col span={8}>
                    {Object.entries(hotelInfo)?.length > 0 ? (
                        <Card
                            hoverable
                            className="margin-10 box-shadow hotel-dashboard-cards"
                            title={
                                <Typography.Text strong>
                                    Hotel Info
                                </Typography.Text>
                            }
                        >
                            {Object.entries(hotelInfo).map(([key, value]) => {
                                if (titleMapings[key]) {
                                    return (
                                        <p key={key}>
                                            {`${titleMapings[key]} : ${
                                                value ?? "NA"
                                            }`}
                                        </p>
                                    );
                                }
                                return "";
                            })}
                        </Card>
                    ) : (
                        <Skeleton active title={false} />
                    )}
                </Col>
                {vendorInfo.length > 0 && (
                    <Col span={8}>
                        <Card
                            hoverable
                            className="margin-10 box-shadow hotel-dashboard-cards"
                            title={
                                <Typography.Text strong>
                                    Vendor Info
                                </Typography.Text>
                            }
                        >
                            {vendorInfo.map((vendor) =>
                                Object.entries(vendor).map(([key, value]) => {
                                    if (titleMapings[key]) {
                                        return (
                                            <p key={key}>
                                                {`${titleMapings[key]} : ${
                                                    value ?? "NA"
                                                }`}
                                            </p>
                                        );
                                    }
                                    return "";
                                }),
                            )}
                        </Card>
                    </Col>
                )}
                {kioskPropertiesStatus !== "loading" &&
                    Object.entries(kioskProperties)?.length > 0 && (
                        <Col span={8}>
                            <Card
                                hoverable
                                className="margin-10 box-shadow hotel-dashboard-cards"
                                title={
                                    <Typography.Text strong>
                                        Kiosk Proprties
                                    </Typography.Text>
                                }
                            >
                                {Object.entries(kioskProperties).map(
                                    ([key, value]) => {
                                        if (titleMapings[key]) {
                                            if (key == "shift_timings") {
                                                value = value.map((timing) => {
                                                    return timing?.type
                                                        ? `${
                                                              timing.type
                                                          } (${formatDate(
                                                              timing.start_time,
                                                              "HH:mm",
                                                          )}  - ${formatDate(
                                                              timing.end_time,
                                                              "HH:mm",
                                                          )})`
                                                        : "";
                                                });
                                            }
                                            if (key == "shift_settings") {
                                                value = weekDays.map(
                                                    (day, index) =>
                                                        `${day.title} (${
                                                            value[index] != ""
                                                                ? value[index]
                                                                : "NA"
                                                        })`,
                                                );
                                            }
                                            return (
                                                <p key={key}>
                                                    {`${titleMapings[key]} : ${
                                                        value ?? "NA"
                                                    }`}
                                                </p>
                                            );
                                        }
                                        return "";
                                    },
                                )}
                            </Card>
                        </Col>
                    )}

                {/* <Col span={6}>
                    <>
                        <Typography.Text className="margin-10" strong>
                            Tickets
                        </Typography.Text>
                        <Card
                            hoverable
                            title={
                                <Typography.Text strong>Open</Typography.Text>
                            }
                            onClick={() =>
                                navigate(
                                    `/hotel-dashboard/tickets/1?id=${search.get(
                                        "id",
                                    )}`,
                                )
                            }
                            className="box-shadow margin-10"
                        >
                            <p>{tickets?.open_tickets || 0}</p>
                        </Card>
                        <Card
                            hoverable
                            title={
                                <Typography.Text strong>Close</Typography.Text>
                            }
                            onClick={() =>
                                navigate(
                                    `/hotel-dashboard/tickets/2?id=${search.get(
                                        "id",
                                    )}`,
                                )
                            }
                            className="box-shadow margin-10"
                        >
                            <p>{tickets?.close_tickets || 0}</p>
                        </Card>
                    </>
                </Col> */}
            </Row>
            <Row>
                {kioskStatistics?.cardData ? (
                    kioskStatistics?.cardData.map((c) => {
                        return (
                            <Col key={c.title} span={4}>
                                <Card
                                    hoverable
                                    className="dashboard-counts margin-10 box-shadow"
                                    onClick={() => {
                                        if (c.key == "spticket_count")
                                            navigate("/support-details-table", {
                                                state: {
                                                    id: Number(hotel_id),
                                                    filter: true,
                                                },
                                            });
                                    }}
                                >
                                    <div className="dashboard-counts-card-body">
                                        <div className="dashboard-counts-diff-new">
                                            <span className="dashboard-counts-card-body-value">
                                                {Number(c.value)}
                                            </span>
                                        </div>
                                        <span className="dashboard-counts-card-header-title">
                                            {c.title}
                                        </span>
                                        <img
                                            src={c.Icon}
                                            alt={c.title}
                                            className="dashboard-counts-card-header-icon"
                                        />
                                    </div>
                                </Card>
                            </Col>
                        );
                    })
                ) : (
                    <Skeleton title={false} active paragraph={{ rows: 10 }} />
                )}
            </Row>

            <Card hoverable className="margin-10 box-shadow">
                <Form onFinish={saveHotelNotes}>
                    {editorText !== null && <div ref={editorRef}></div>}
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </Card>
    );
}

export { HotelDashboard };
